import type { AlibabaModelConfig, StatusMapping } from './types';
import { happyhorseConfigs } from './configs/happyhorse';
import { wanConfigs } from './configs/wan';

// create api are different for all models, but poll api and status mapping are the same for all models

/**
 * Alibaba 状态映射配置（所有模型统一使用）
 */
export const alibabaStatusMapping: StatusMapping = {
    /** 任务 ID 字段路径 */
    taskIdPath: 'output.task_id',
    /** 状态字段路径 */
    statePath: 'output.task_status',
    /** 成功状态值 */
    success: ['SUCCEEDED'],
    /** 失败状态值 */
    failed: ['FAILED', 'CANCELED'],
    /** 处理中状态值 */
    processing: ['PENDING', 'RUNNING', 'UNKNOWN'],
    /** 视频 URL 字段路径 */
    videoUrlPath: 'output.video_url',
    /** 错误信息字段路径 */
    errorPath: 'output.message',
};

/**
 * 模型配置映射
 */
export const alibabaModelConfigs: Record<string, AlibabaModelConfig> = {
    ...happyhorseConfigs,
    ...wanConfigs,
};
